export default "__VITE_ASSET__BFS8puYE__"